export const BASE_URL = "https://api.playfortune.bet";

export const API_ENDPOINTS = {
  gameConfig: `${BASE_URL}/api/games/gameconfig/getconfig`,
  roundResults: `${BASE_URL}/api/rounds/list/getallroundsresult`,
} as const;
